import React from "react";

export default function DietTagFilter({ tag, setDietFilter, selected }) {

    return (
        <div
            className={selected ? "diet_tag_filter_container_selected" : "diet_tag_filter_container"}
            onClick={() => {
                setDietFilter(prev =>
                    prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
                );
            }}
            key={tag}
        >
            <p>{tag}</p>
        </div>
    )
}